import React from "react";
import PropTypes from "prop-types";
import CustomTextField from "./CustomTextField";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";

function CustomFields(props) {
  const [customFields, setCustomFields] = React.useState(props.customFields);

  return (
    <div>
      <Grid container spacing={1}>
        {customFields.map((customField, index) => {
          switch (customField.type) {
            case "text":
              return (
                <>
                  <CustomTextField
                    customField={customField}
                    onChange={(customField) => {
                      let newCustomFields = [...customFields];
                      newCustomFields.splice(index, 1, customField);
                      setCustomFields(newCustomFields);
                      props.onChange(newCustomFields);
                    }}
                    onRemove={() => {
                      let newCustomFields = [...customFields];
                      newCustomFields.splice(index, 1);
                      setCustomFields(newCustomFields);
                      props.onChange(newCustomFields);
                    }}
                  />
                  <Divider />
                </>
              );
            default:
              return null;
          }
        })}
        <Grid item xs={12}>
          <Button
            variant={"contained"}
            color={"primary"}
            onClick={() => {
              let newCustomFields = [...customFields];
              newCustomFields.push({ label: "", type: "text", required: true });
              setCustomFields(newCustomFields);
              props.onChange(newCustomFields);
            }}
          >
            Add
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}

CustomFields.propTypes = {
  customFields: PropTypes.instanceOf(Array).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CustomFields;
